import React, { Component } from "react";

import X_BARReportView from "../../../components/Common/X-BARReportView";

class OBARReport extends Component {
  render() {
    return (
      <X_BARReportView
        {...this.props}
        reportType="obar"
        patientId={this.props.match.params.patientId}
        location={this.props.location}
      />
    );
  }
}

export default OBARReport;
